import jQuery from 'jquery';
// Expose global for legacy plugins
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).$ = jQuery;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(window as any).jQuery = jQuery;
export default jQuery;
